module.exports = __webpack_public_path__ + "img/121.d2ae9f34.jpg";